import { useEffect, useRef } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';
import type { FolderType } from '../constants';

interface UseLogViewFolderParams {
  folderSno: number;
  folderType: FolderType;
  folderName?: string | null;
  likesCount?: number | null;
}

export const useLogViewFolder = ({
  folderSno,
  folderType,
  folderName,
  likesCount,
}: UseLogViewFolderParams) => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  const loggedRef = useRef(false);

  useEffect(() => {
    if (loggedRef.current) return;
    if (folderName == null) return;
    loggedRef.current = true;
    logAnalyticsEvent({
      name: 'VIEW_FOLDER',
      analytics: {
        FOLDER_SNO: folderSno.toString(),
        FOLDER_TYPE: folderType,
        FOLDER_NAME: folderName,
        LIKES_COUNT: likesCount ?? 0,
      },
    });
  }, [folderSno, folderType, folderName, likesCount, logAnalyticsEvent]);
};
